import { makeStyles } from '@material-ui/core';
import { Product } from '../api';
import { Colors } from '../components/controls/helpers';

interface ProductProps {
    product: Product;
}

export const ProductStyles = {
    [Product.KiwiSaver]: {
        color: Colors.Green,
        darkColor: '#1FBB55',
        medColor: '#64D68B',
        lightColor: '#BCEECD'
    },
    [Product.WealthBuilder]: {
        color: '#F45F3E',
        darkColor: '#E85A3B',
        medColor: '#F78F78',
        lightColor: '#FCCFC5'
    },
    [Product.IncomeGenerator]: {
        color: '#0053F3',
        darkColor: '#0053F3',
        medColor: '#64D68B',
        lightColor: '#0053F3'
    },
};

export const useSharedStyles = makeStyles({
    input: {
        backgroundColor: `${Colors.White} !important`,
        '& :disabled': {
            /* Work around for iOS disabled fields */
            '-webkit-text-fill-color': Colors.Grey,
            opacity: 1
        }
    },
    form: {
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column'
    },
    text: {
        color: `${Colors.DarkGrey} !important`,
        lineHeight: '1.375rem !important',
        marginBottom: 12
    },
    smallPrint: {
        color: `${Colors.DarkGrey} !important`,
        fontSize: '0.66rem !important'
    },
    white: {
        color: `${Colors.White} !important`
    },
    black: {
        color: `${Colors.Black} !important`
    }
}, { name: 'SharedStyles'});

export const useProductStyles = makeStyles({
    backgroundColor: (props: ProductProps) => ({
        backgroundColor: `${ProductStyles[props.product].color} !important`
    }),
    darkBackgroundColor: (props: ProductProps) => ({
        backgroundColor: `${ProductStyles[props.product].darkColor} !important`
    }),
    medBackgroundColor: (props: ProductProps) => ({
        backgroundColor: `${ProductStyles[props.product].medColor} !important`
    }),
    lightBackgroundColor: (props: ProductProps) => ({
        backgroundColor: `${ProductStyles[props.product].lightColor} !important`
    }),
    color: (props: ProductProps) => ({
        color: `${ProductStyles[props.product].color} !important`
    }),
    darkColor: (props: ProductProps) => ({
        color: `${ProductStyles[props.product].darkColor} !important`
    }),
    borderColor: (props: ProductProps) => ({
        borderColor: `${ProductStyles[props.product].color} !important`
    }),
    lightBorderColor: (props: ProductProps) => ({
        borderColor: `${ProductStyles[props.product].lightColor} !important`
    })
}, { name: 'ProductStyles'});
